import React from 'react';
import {FormattedMessage} from 'react-intl';

import {
  CommentTextArea,
  FieldDiv,
  FieldRow,
  Label
} from './CheckoutPage.style';

const Comments = () => {
  return (
    <FieldRow>
      <FieldDiv nomargin>
        <Label for="comments">
          <FormattedMessage id="checkout.comment" />
          <CommentTextArea
            id="comments"
            name="comments"
            maxLength="256"
            component="textarea"
          />
        </Label>
      </FieldDiv>
    </FieldRow>
  );
};

export default Comments;



// WEBPACK FOOTER //
// ./containers/CheckoutPage/Comments.js